import {SET_SELECTED_MENU_ITEM} from "../constants/about";

export const setSelectedMenuItem = (selectedMenuItem) => {
    return {
        type: SET_SELECTED_MENU_ITEM,
        selectedMenuItem
    }
}